import { default as Modal } from "./Modal";
import { Button, DeleteButton, IButtonProps } from "./Button";

export interface IModalProps {
  showModal: boolean;
  setShowModal: Function;
  confirmAction: () => void;
  cancelAction?: () => void;
  children?: React.ReactNode | string;
}

const ConfirmationPopup = ({
  confirmAction,
  cancelAction,
  ActionButton,
  showModal,
  setShowModal,
  children,
}: IModalProps & {
  ActionButton: (props: IButtonProps) => JSX.Element;
}) => {
  return (
    <Modal showModal={showModal} setShowExternal={setShowModal}>
      <Modal.Display
        useCloseBtn={false}
        tailwindWidth="w-auto"
        tailwindHeight="h-auto"
      >
        <Modal.Body>
          <div className="bg-white px-6 py-4 flex flex-col gap-6 justify-between rounded-md text-sm">
            <div className="flex-grow grid place-content-center py-2">
              {children}
            </div>
            <div className="flex gap-4 justify-center">
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  setShowModal(false);
                  if (cancelAction) cancelAction();
                }}
              >
                Cancel
              </Button>
              <ActionButton
                onClick={(e) => {
                  e.preventDefault();
                  confirmAction();
                }}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal.Display>
    </Modal>
  );
};

const DeletePopup = ({
  CustomMessage,
  ...props
}: IModalProps & { CustomMessage?: string | React.ReactNode }) => (
  <ConfirmationPopup ActionButton={DeleteButton} {...props}>
    {CustomMessage || `Are you sure you want to delete this item?`}
  </ConfirmationPopup>
);

export { ConfirmationPopup, DeletePopup };
